export function inflate(rect, dx, dy) {
    return {
        x: rect.x - dx,
        y: rect.y - dy,
        width: rect.width + 2 * dx,
        height: rect.height + 2 * dy,
    };
}
//# sourceMappingURL=math.js.map